<!--
 * @Description: 首页线索概括列表
 * @Author: mdb
 * @Date: 2023-04-10 15:17:32
 * @LastEditTime: 2023-04-17 17:08:03
 * @LastEditors: mdb
-->
<template>
  <ul class="summary-leads-container">
    <li class="summary-leads-content" :class="item.class" v-for="item in summaryEnumComputed" :key="item.key">
      <img class="summary-leads-content_icon" :src="item.icon" />
      <div class="summary-leads-content_controls">
        <h4 class="summary-leads-content_controls__label">{{ item.label }}</h4>
        <p class="summary-leads-content_controls__value">{{ item.value || 0 }}</p>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { PropType, ref, computed } from 'vue'
interface SummaryType {
  allClues: number
  effectiveClues: number
  fbuClues: number
  lbuClues: number
  [key: string]: any
}

const props = defineProps({
  value: {
    type: Object as PropType<SummaryType>,
    required: true
  }
})

const summaryEnum = ref([
  { label: '全部线索', value: 0, class: 'all', key: 'allClues', icon: require('@/assets/index/new-clue.svg') },
  { label: '有效线索', value: 0, class: 'valid', key: 'validClues', icon: require('@/assets/index/new-business.svg') },
  { label: '未来线索', value: 0, class: 'future', key: 'futureClues', icon: require('@/assets/index/new-visitor.svg') },
  { label: '投放线索', value: 0, class: 'put', key: 'pushClues', icon: require('@/assets/index/new-follow.svg') },
  { label: '无效线索', value: 0, class: 'invalid', key: 'invalidClues', icon: require('@/assets/index/clue.svg') }
])

const summaryEnumComputed = computed(() => {
  return summaryEnum.value.map((item: any) => {
    item.value = props.value ? props.value[item.key] : 0
    return item
  })
})
</script>
<script lang="ts">
export default { name: 'SummaryLeads' }
</script>

<style lang="scss" scoped>
.summary-leads-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  line-height: 1;
}
.summary-leads-content {
  flex: 1;
  display: flex;
  align-items: center;
  height: 94px;
  margin-right: 8px;
  padding-left: 20px;
  border-radius: 2px;
  &:last-child {
    margin-right: 0;
  }
  &.all {
    border-left: 4px solid #877ced;
    background: #efecfd;
    .summary-leads-content_controls__value {
      color: #877ced;
    }
  }
  &.valid {
    border-left: 4px solid #36c8e1;
    background: #e4f8fb;
    .summary-leads-content_controls__value {
      color: #36c8e1;
    }
  }
  &.future {
    border-left: 4px solid #4ec690;
    background: #e5f7ed;
    .summary-leads-content_controls__value {
      color: #4ec690;
    }
  }
  &.put {
    border-left: 4px solid #ffb648;
    background: #fdf1e2;
    .summary-leads-content_controls__value {
      color: #ffb648;
    }
  }
  &.invalid {
    border-left: 4px solid #ffa1a1;
    background: #ffe2e2;
    .summary-leads-content_controls__value {
      color: #ffa1a1;
    }
  }
  // .summary-leads-content_icon {}
  .summary-leads-content_controls {
    margin-left: 16px;
    .summary-leads-content_controls__label {
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
    }
    .summary-leads-content_controls__value {
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>
